// features/message/messageSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  count: 0,
};

const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    setNotificationTotalCount: (state, action) => {
      state.count = action.payload;
    },
    incrementNotificationCount: (state) => {
      state.count += 1;
    },
  },
});

export const { setNotificationTotalCount, incrementNotificationCount } = messageSlice.actions;
export default messageSlice.reducer;
